module.exports = __webpack_public_path__ + "images/cfa790b7b0e5fb82d853c14c3597f461.png";